import React from 'react'
import {ModeleSavLigne} from '../../../../components/sav/Models'
import {formatSavDate} from '../../../../components/sav/libelles'

// Badge de garantie d'une ligne : « Jusqu'au … », hors garantie, déclarative si la date d'achat n'est pas vérifiée
const SavGarantie = ({ligne, declarative}: {ligne: ModeleSavLigne; declarative: boolean}) => {
  if (!ligne.dateFinGarantie) return <span className='text-muted fs-7'>Date d'achat inconnue</span>
  const sous = new Date(ligne.dateFinGarantie) >= new Date()
  return (
    <span className={`badge ${sous ? 'badge-light-success' : 'badge-light-danger'}`}>
      {sous
        ? `Jusqu'au ${formatSavDate(ligne.dateFinGarantie)}`
        : `Hors garantie depuis le ${formatSavDate(ligne.dateFinGarantie)}`}
      {declarative && ' · déclarative'}
    </span>
  )
}

export const estSousGarantie = (ligne: ModeleSavLigne) =>
  !ligne.dateFinGarantie || new Date(ligne.dateFinGarantie) >= new Date()

export default SavGarantie
